<template>
  <section>
    <div class="mb-25">
      <vue-content-loading :width="600" :height="185">
        <rect x="0" y="0" rx="5" ry="5" width="290" height="185" />
        <rect x="300" y="10" rx="4" ry="4" width="300" height="40" />
        <rect x="300" y="55" rx="4" ry="4" width="150" height="40" />
        <rect x="300" y="120" rx="4" ry="4" width="300" height="10" />
        <rect x="300" y="140" rx="4" ry="4" width="250" height="10" />
        <rect x="300" y="160" rx="4" ry="4" width="290" height="10" />
      </vue-content-loading>
    </div>
    <div class="mb-25">
      <vue-content-loading :width="600" :height="185">
        <rect x="0" y="0" rx="5" ry="5" width="290" height="185" />
        <rect x="300" y="10" rx="4" ry="4" width="300" height="40" />
        <rect x="300" y="55" rx="4" ry="4" width="150" height="40" />
        <rect x="300" y="120" rx="4" ry="4" width="300" height="10" />
        <rect x="300" y="140" rx="4" ry="4" width="250" height="10" />
        <rect x="300" y="160" rx="4" ry="4" width="290" height="10" />
      </vue-content-loading>
    </div>
    <!-- <div class="mb-25">
      <vue-content-loading :width="600" :height="185">
        <rect x="0" y="0" rx="5" ry="5" width="290" height="185" />
        <rect x="300" y="10" rx="4" ry="4" width="300" height="40" />
        <rect x="300" y="55" rx="4" ry="4" width="150" height="40" />
        <rect x="300" y="120" rx="4" ry="4" width="300" height="10" />
        <rect x="300" y="140" rx="4" ry="4" width="250" height="10" />
        <rect x="300" y="160" rx="4" ry="4" width="290" height="10" />
      </vue-content-loading>
    </div>
    <div class="mb-25">
      <vue-content-loading :width="600" :height="185">
        <rect x="0" y="0" rx="5" ry="5" width="290" height="185" />
        <rect x="300" y="10" rx="4" ry="4" width="300" height="40" />
        <rect x="300" y="55" rx="4" ry="4" width="150" height="40" />
        <rect x="300" y="120" rx="4" ry="4" width="300" height="10" />
        <rect x="300" y="140" rx="4" ry="4" width="250" height="10" />
        <rect x="300" y="160" rx="4" ry="4" width="290" height="10" />
      </vue-content-loading>
    </div> -->
  </section>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'CategoriaLoading',
  components: {
    VueContentLoading,
  },
};
</script>

<style lang="scss" scoped>
section {
  // background: #f7f6f8;

  & .float-left {
    float: left;
  }

  & .mb-25 {
    margin-bottom: 25px !important;
  }
  & .mb-10 {
    margin-bottom: 0px !important;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  section {
    max-height: 100vh;
    min-height: 100vh !important;
    opacity: 0;
    display: none;
  }
}
</style>
